import { partial } from 'lodash';
import { SimpleMenu } from 'venn-ui-kit';
import React from 'react';
import { ActionsButton, GreyIcon, StyledBaseDropMenu } from '../AllocationStrategyActions';

interface PrivatesFundActionsProps {
  onDelete: () => void;
}
export const PrivatesFundActions = ({ onDelete }: PrivatesFundActionsProps) => {
  const options = [
    {
      label: 'Delete',
      value: onDelete,
    },
  ];

  return (
    <StyledBaseDropMenu
      style={{ position: 'absolute' }}
      className="drop-menu"
      usePortal
      filteredItems={options}
      triggerComponent={(_, _highlighted, onToggle) => (
        <ActionsButton onClick={partial(onToggle, undefined)} className="qa-strategy-actions">
          <GreyIcon type="ellipsis-h" />
        </ActionsButton>
      )}
      menuComponent={(_, onCollapse, menuClassName) => (
        <SimpleMenu
          className={menuClassName}
          items={options}
          selected={null}
          onChange={(item) => {
            onCollapse();
            item?.value?.();
          }}
        />
      )}
    />
  );
};
